import React from 'react'
import { AutoComplete, Button, Dropdown, Input, Space, Switch } from 'antd';
import { ConsoleSqlOutlined, DownOutlined } from '@ant-design/icons';
import { useState } from 'react';
import { useEffect } from 'react';
import CustomDropDownAutoComplete from '../AntD/DropDown';
import { exportLocomotive, exportLocomotiveTicket, exportWorkOrders, getAllLocomotiveTicketSources } from '../../Services/LocomotiveServices';
import { seriliazeParams } from '../../helpers/seriliazeParams';
import CustomDropDownMultipleAutoComplete from '../AntD/MultipleDropDown';
import './TableFilter.css';
import roleManager from '../roles';
const { Search } = Input;

const TableFilters = ({ mode, exportData, pagination, flag, placeholder, setSwitchRadio, setEdit, edit, callApi, options = { searchBar: true, moreFilter: true, locationData: { data: [] }, equipIdData: { data: [] }, employeeData: { data: [] }, sourceData: { data: [] } }, states = {}, deleteBtn }) => {


    let { searchBar, moreFilter, locationData, equipIdData, employeeData, sourceData,employeeContData } = options
    const { equipId, setEquipId, LocationId, setLocationId, sourceID, setSourceID, RequestedForId, setRequestedForId, setSelectedOpen, selectedOpen, selectedAssignTo, setSelectedAssignTo } = states


    // const [selectedAssignTo, setSelectedAssignTo] = useState(null);
    const [assignToData, setAssignToData] = useState([]);
    const [tableData, setTableData] = useState([]); // State to store table data
    const [toggleState, setToggleState] = useState(false);

    useEffect(() => {
        if (mode == 'ticket' && !selectedOpen)
            setSelectedOpen(1)
    }, [])


    const statusData = [
        {
            label: "Open",
            value: 'Open'
        },
        {
            label: "Assigned",
            value: 'Assigned'
        },
        {
            label: "Scheduled",
            value: 'Scheduled'
        },
        {
            label: "Cmpl Pending Review",
            value: 'Cmpl Pending Review'
        },
        // {
        //     label: "Closed",
        //     value: 'Closed'
        // },
        {
            label: "Reviewed-Approved",
            value: 'Reviewed-Approved'
        },
        {
            label: "Closed-WNC",
            value: 'Closed-WNC'
        },


    ]



    const openCloseData = [
        {
            value: 1,
            label: 'Open'
        },
        {
            value: 2,
            label: 'Closed'
        },
        {
            value: 3,
            label: 'All'
        },
    ]
    const exportLocomotiveSheet = async () => {
        exportData(LocationId, equipId, selectedOpen, RequestedForId, sourceID, selectedAssignTo, toggleState)

    }
    useEffect(() => {
        setSwitchRadio(selectedOpen)
        callApi(LocationId, equipId, selectedOpen, RequestedForId, sourceID, selectedAssignTo, toggleState)
    }, [LocationId, equipId, selectedOpen, RequestedForId, sourceID, flag, pagination, selectedAssignTo, toggleState])
    useEffect(() => {
        setEdit(!edit)
    }, [LocationId, equipId, selectedOpen, RequestedForId, sourceID,])
    const handleReset = () => {
        setLocationId(null);
        setEquipId(null);
        setRequestedForId(null);
        setSourceID(null);
        setSelectedAssignTo(null);
        if (mode === 'ticket')
            setSelectedOpen(1);
        else
            setSelectedOpen(null);

    }

    return (
        <div style={{
            margin: "10px 0px",
            display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%", flexWrap: "wrap"
        }}>

            {
                moreFilter &&
                <div style={{
                    // padding: "20px",
                    display: "flex",
                    gap: "10px",
                    alignItems: "center",
                    flexWrap: "wrap"
                }}>
                    <CustomDropDownAutoComplete id="equipID" width='140px' items={equipIdData.data} selectedName={equipId ? equipId : "Equipment ID "} setSelectedName={setEquipId} />
                    <CustomDropDownAutoComplete id="requestedForID" width='140px' items={employeeData.data} selectedName={RequestedForId ? RequestedForId : mode === "ticket" ? "Requested For" : "Created By"} setSelectedName={setRequestedForId} />

                    {mode === "ticket" ? <CustomDropDownAutoComplete id="source" width='120px' items={sourceData.data} selectedName={sourceID ? sourceID : "Source "} setSelectedName={setSourceID} /> : <></>}

                    <CustomDropDownAutoComplete id="locationID" width='240px' items={locationData.data} selectedName={LocationId ? LocationId : "Location"} setSelectedName={setLocationId} />


                    {mode === "ticket" ? (
                        <CustomDropDownAutoComplete
                            id="statusID"
                            width='120px'
                            items={openCloseData}
                            selectedName={selectedOpen ? selectedOpen : "Status"}
                            setSelectedName={setSelectedOpen}
                        />
                    ) : (
                        <CustomDropDownMultipleAutoComplete
                            id="statusID"
                            width='210px'
                            items={statusData}
                            selectedName={selectedOpen ? selectedOpen : []}
                            setSelectedName={setSelectedOpen}
                            multiple // Add a 'multiple' prop to indicate that it supports multiple selection
                            placeholder={'Status'}
                            className='Updated'

                        />
                    )}


                    {mode !== "ticket" && roleManager("employeeLookup", "sections", "workOrderFilter")
                        ? (

                            <CustomDropDownAutoComplete
                                id="assignedToID"
                                width='160px'
                                items={employeeContData?.data}
                                selectedName={selectedAssignTo ? selectedAssignTo : "Assigned To"}
                                setSelectedName={setSelectedAssignTo}
                            />
                        ) : (
                            <></>
                        )}
                </div>

            }

            <>
{ }
                <div style={{ display: "flex", justifyContent: "end", alignItems:"center" }}>

                    {deleteBtn}

                    <Button onClick={() => {
                        exportLocomotiveSheet()
                    }} style={{ backgroundColor: "#2963ad", color: "white" }}>
                        Export
                    </Button>

                    <Button onClick={() => {
                        handleReset()
                        mode === "ticket" && setSourceID()
                    }} style={{ width: '100px', backgroundColor: "#2963ad", color: "white" }}>
                        Reset
                    </Button>



                </div>
            </>
            {/* <div style={{ marginTop: '10px' }}>
                {mode !== 'ticket' && (
                    <label>
                        <strong>Closed WO</strong>
                        <Switch
                            checked={toggleState}
                            onChange={(value) => setToggleState(value)}
                            style={{ marginLeft: '10px' }}
                        />
                    </label>
                )}
            </div> */}
        </div>
    )
}

export default TableFilters


// let employeeList = await employee.get_employee_listing()
